import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DevicePreviewComponent } from './device-preview.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DevicePreviewComponent],
  imports: [CommonModule, TranslateModule],
  exports: [DevicePreviewComponent],
})
export class DevicePreviewModule {}
